import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import UrlAwareText from 'ui-library/UrlAwareText';

export interface MetadataEditorUnitAwareTagValueViewerProps {
  textValue: string;
  unitSymbol: string;
}

export default function MetadataEditorUnitAwareTagValueViewer({
  textValue,
  unitSymbol,
}: MetadataEditorUnitAwareTagValueViewerProps): JSX.Element {
  if (textValue.length === 0) {
    return <UrlAwareText textValue={textValue} className={css(styles.text)} />;
  }
  const textWithUnit = `${textValue} ${unitSymbol}`;
  return <UrlAwareText textValue={textWithUnit} className={css(styles.text)} />;
}

export const styles = StyleSheet.create({
  text: {
    maxWidth: '100%',
    whiteSpace: 'pre-wrap',
    wordWrap: 'break-word',
  },
});
